module.exports = __webpack_public_path__ + "img/img08.da071e05.svg";